<template lang="pug">
  div
    InfoPopup(:isVisibleModal="isShowInfoPopup", :id="id", :name="name", @close-info-popup="closeInfoPopup")
    v-dialog(
      v-model="isShow",
      fullscreen,
      scrollable,
      persistent,
      hide-overlay)
      v-card
        ToolbarView(
          :name="name",
          @open-info-popup="showInfoPopup"
          @open-filters-form="openFilterFieldsForm"
          @get-search="search",
          @search-value="setSearchValue",
          @add-new-record="addNewRecord",
          @close-modal="close")
        v-card-text.fill-height.pt-0
          v-layout(row justify-center)
            v-flex(xs12)
              v-data-table(
                :items="items",
                :pagination.sync="pagination",
                :headers="headers",
                hide-actions,
                no-data-text="Нет данных для отображения")
                template(slot="headerCell" slot-scope="props")
                  span(@click.prevent="getSort(props.header.value)") {{ props.header.text }}
                template(slot="items" slot-scope="props")
                  tr(@click.prevent="editRecord(idsList[props.index])",
                    style="cursor: pointer;")
                    td(v-for="prop in props.item") {{ prop }}
        v-card-actions.pb-3
          v-layout(justify-center)
            v-flex(xs10 text-xs-center)
              v-pagination(v-model="page", total-visible="7", :length="pages").my-1
        AddNewRecord(
          :id="id",
          :page="page",
          :size="pagination.rowsPerPage",
          :recordItem="recordItem",
          :edit="isEdit",
          :show="dialog",
          :name="name",
          :historyDates="historyDates",
          @clear-history-dates="historyDates = []",
          @close-edit="closeEdit")
        FilterFields(
          :show="showFilterDialog",
          @close-filter-fields-dialog="closeFilterFieldsForm",
          @save-user-fields="saveUserFields")
</template>

<script>
import { _ } from 'vue-underscore'
import ToolbarView from './Common/ToolbarView'
import AddNewRecord from './AddNewRecord'
import FilterFields from './FilterFields'
import axios from 'axios'
import InfoPopup from './Common/InfoPopup'
export default {
  components: {
    InfoPopup,
    FilterFields,
    AddNewRecord,
    ToolbarView
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isEdit: false,
    recordItem: {},
    pagination: {
      rowsPerPage: 10
    },
    page: 1,
    dialog: false,
    searchValue: null,
    headers: [],
    items: [],
    sort: false,
    show: false,
    showFilterDialog: false,
    formId: '',
    historyDates: [],
    isShowInfoPopup: false
  }),
  watch: {
    id(val) {
      if (val) this.formId = val
    },
    searchValue(val) {
      if (val === null || !val.length) {
        this.page = 1
        this.$store.dispatch('GET_DB_RECORDS_LIST', {
          id: this.id,
          page: this.page,
          size: this.pagination.rowsPerPage
        })
      }
    },
    'pagination.rowsPerPage': {
      deep: true,
      handler(val) {
        this.page = 1
        if (this.id) {
          if (this.searchValue !== null) {
            this.search(this.page)
          }
        }
      }
    },
    page(val) {
      if (this.searchValue !== null) {
        this.search(val)
      } else {
        if (val !== 1) {
          this.$store.dispatch('GET_DB_RECORDS_LIST', {
            id: this.id,
            page: this.page,
            size: this.pagination.rowsPerPage
          })
        }
      }
    },
    headersList(val) {
      this.headers = val
    },
    recordsList(val) {
      this.items = val
    },
    isEdit() {
      return this.$store.state.db.dbRecordsList.edit
    }
  },
  computed: {
    idsList() {
      const val = this.$store.state.db.dbRecordsList.models
      const array = []
      val.map(item => {
        array.push(item.id)
      })
      return array
    },
    recordsList: {
      get() {
        let val = this.$store.state.db.dbRecordsList.models
        let array = []
        if (val && this.selectValue !== '') {
          const rows = Object.keys(val).length
          const colNames = this.headersList.map(val => {
            return val.value
          })
          const colsData = []
          val.map(item => {
            colsData.push(item.model)
          })
          for (let i = 0; i < rows; i++) {
            array.push([])
            colNames.map((name, j) => {
              array[i][j] = '---'
              _.keys(colsData[i]).find(it => {
                if (name === 'countIndex') {
                  array[i][j] =
                    this.pagination.rowsPerPage * this.page - this.pagination.rowsPerPage + i + 1
                }
                if (name === it) {
                  if (colsData[i][it] === '' || colsData[i][it] === null) {
                    array[i][j] = '---'
                  } else {
                    // console.log(it)
                    // console.log(colsData[i][it])
                    switch (typeof colsData[i][it]) {
                      case 'string':
                        if (it.indexOf('map') !== -1) {
                          array[i][j] = 'Полигон на карте'
                        } else {
                          array[i][j] = colsData[i][it]
                        }
                        if (it.indexOf('checkbox') !== -1) {
                          let text = ''
                          colsData[i][it] ? (text = 'да') : (text = 'нет')
                          array[i][j] = text
                        }
                        if (it.indexOf('date') !== -1) {
                          array[i][j] = this.moment(JSON.parse(colsData[i][it])).format(
                            'DD.MM.YYYY'
                          )
                        } else {
                          array[i][j] = colsData[i][it]
                        }
                        break
                      case 'boolean':
                        let text = ''
                        colsData[i][it] ? (text = 'да') : (text = 'нет')
                        array[i][j] = text
                        break
                      case 'number':
                        if (it.indexOf('date') !== -1) {
                          array[i][j] = this.moment(colsData[i][it]).format('DD.MM.YYYY')
                        } else {
                          array[i][j] = colsData[i][it]
                        }
                        break
                      default:
                        array[i][j] = colsData[i][it]
                        break
                    }
                  }
                }
              })
            })
          }
          return array
        } else {
          return []
        }
      },
      set() {
        return []
      }
    },
    headersList() {
      let val = this.$store.state.db.dbRecordsList.labels
      if (val && this.selectValue !== '') {
        const array = []
        Object.keys(val).map((item, index) => {
          array.push({
            text: val[item],
            value: item,
            sortable: true
          })
        })
        array.unshift({
          text: '№',
          sortable: false,
          value: 'countIndex'
        })
        return array
      }
    },
    dbRecordsList() {
      return this.$store.state.db.dbRecordsList.models
    },
    // rowCount() {
    //   return this.$store.getters.rowCount
    // },
    // havePermission() {
    //   return this.$store.state.db.dbRecordsList.edit
    // },
    pages() {
      return this.$store.getters.pageCount
    }
  },
  methods: {
    showInfoPopup() {
      this.isShowInfoPopup = true
    },
    closeInfoPopup() {
      this.isShowInfoPopup = false
    },
    setSearchValue(value) {
      this.searchValue = value
    },
    search(page) {
      const data = {
        dbId: this.id,
        searchString: this.searchValue,
        page: page,
        size: this.pagination.rowsPerPage
      }
      this.$store.dispatch('SEARCH_DB_RECORDS', data)
    },
    close() {
      this.$emit('close-dialog', false)
      this.searchValue = null
      this.pagination.rowsPerPage = 10
      this.page = 1
    },
    closeEdit() {
      this.dialog = false
      this.isEdit = false
      this.recordItem = {}
    },
    getHistoryDates(id) {
      return axios({
        method: 'GET',
        url: `/api/history/get-dates/${id}`
      })
        .then(response => {
          this.historyDates = response.data.result
        })
        .catch(error => {
          console.log(error)
        })
    },
    async editRecord(id) {
      if (this.id !== '274f0c5d-2c02-43b2-8d59-77e73b4494ea') await this.getHistoryDates(id)
      this.recordItem = await this.dbRecordsList.find(item => {
        if (item.id === id) {
          return { ...item }
        }
      })
      this.isEdit = true
      this.dialog = true
    },
    addNewRecord() {
      this.dialog = true
    },
    getSort(id) {
      this.text = id
      this.sort = !this.sort
      const data = {
        fieldId: id,
        id: this.id,
        page: this.page,
        size: this.pagination.rowsPerPage
      }
      data.sort = this.sort ? 'asc' : 'desc'
      this.$store.dispatch('GET_DB_RECORDS_LIST', data)
    },
    openFilterFieldsForm() {
      this.$store.dispatch('GET_USER_FORM_FIELDS', { id: this.id }).then(() => {
        this.showFilterDialog = true
      })
    },
    closeFilterFieldsForm() {
      this.showFilterDialog = false
    },
    saveUserFields(fields) {
      this.$store.dispatch('POST_USER_FORM_FIELDS', {
        id: this.id,
        page: this.page,
        size: this.pagination.rowsPerPage,
        fields
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.v-card {
  .v-toolbar {
    border-bottom: 1px solid #c3c3c3 !important;
    &__title {
      span {
        color: grey;
        font-size: 1rem;
        font-weight: 400;
      }
    }
    &__items {
      .v-btn {
        border-radius: 4px;
        &.uploadBtn {
          position: relative;
          display: flex !important;
          background: #5ab300;
          color: #fff;
        }
      }
    }
    .v-text-field {
      padding-top: 8px;
      margin-right: 8px;
    }
  }
  &__text {
    .v-table {
      thead {
        display: none;
      }
    }
  }
  &__actions {
    border-top: 1px solid #c3c3c3;
  }
}
.v-overlay--active:before {
  opacity: 0.7;
}
@media only screen and (max-width: 600px) {
  .v-toolbar {
    .xs-close-btn {
      color: #007bff !important;
      margin-right: 0 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DataBase/DataBaseView.vue